export default __webpack_public_path__ + "static/media/glass.83d1b7b3.png";